import { env } from '../env';
import type { AuthProvider } from './auth-provider';
import { MockAuthProvider } from './cognito-mock';
import { CognitoAuthProvider } from './cognito-client';

/**
 * Singleton del provider activo. Se elige al cargar el módulo según
 * `VITE_USE_MOCKS`:
 *   - `true`  → MockAuthProvider (in-memory, usuarios demo)
 *   - `false` → CognitoAuthProvider contra el User Pool del deploy
 */
export const authProvider: AuthProvider = env.useMocks
  ? new MockAuthProvider()
  : new CognitoAuthProvider(env.cognitoUserPoolId, env.cognitoClientId);

export type { AuthSession, AuthProvider } from './auth-provider';
export { AuthError } from './auth-provider';
export { MOCK_USERS, MOCK_USERS_LIST, MOCK_TENANT_ID, MOCK_TENANT_ID_2, DEMO_TENANT_ID } from './cognito-mock';
